import React from "react";
import { Card, Heading, Icon, Text, toast, Tooltip } from "@telia/teddy";
import { DELIVERY_TYPE, DeliveryType } from "../../../../../constants";
import TEXT from "../../text-consts";
import "./ReceiptOrderDetailsCard.less";
import { copyToClipboard } from "../../../../utils/copyToClipboard";

interface ReceiptOrderDetailsCardProps {
    deliveryTitle: string;
    deliveryDescription: string;
    deliveryInfoType?: DeliveryType;
    isDigitalDelivery: boolean;
    orderId: string;
    showTrackingInfo?: boolean;
    children?: React.ReactNode;
}

const ReceiptOrderDetailsCard: React.FC<ReceiptOrderDetailsCardProps> = ({
    deliveryTitle,
    deliveryDescription,
    deliveryInfoType,
    isDigitalDelivery,
    showTrackingInfo,
    orderId,
    children,
}) => (
    <Card layout="default" variant="gray" className="receipt-order-details-card">
        <Card.Heading variant="title-300">{TEXT.RECEIPT.ORDER_DETAILS_HEADING}</Card.Heading>
        <Card.Content>
            <Heading mb="100" asChild variant="title-100">
                <div className="receipt-order-details-card__copy-order">
                    <span>{TEXT.RECEIPT.ORDER_NUMBER}:</span>
                    <Tooltip>
                        <Tooltip.Trigger asChild>
                            <button
                                type="button"
                                className="receipt-order-details-card__copy-order-id"
                                onClick={() => {
                                    copyToClipboard(orderId);
                                    toast.success(TEXT.RECEIPT.COPY_ORDER_ID_SUCCESS);
                                }}
                                aria-label={TEXT.RECEIPT.COPY_ORDER_ID}
                            >
                                {orderId}
                                <Icon name="copy" size="sm" aria-hidden="true" focusable="false" />
                            </button>
                        </Tooltip.Trigger>
                        <Tooltip.Content>
                            <Text>{TEXT.RECEIPT.COPY_ORDER_ID}</Text>
                        </Tooltip.Content>
                    </Tooltip>
                </div>
            </Heading>
            {(deliveryTitle || deliveryDescription) && (
                <>
                    <Heading mb="100" asChild variant="title-100">
                        <span>{TEXT.RECEIPT.DELIVERY}:</span>
                    </Heading>
                    <Text as="div">
                        {deliveryTitle ? (
                            <>
                                {deliveryTitle}
                                <br />
                            </>
                        ) : null}
                        {deliveryDescription}
                        {deliveryInfoType !== DELIVERY_TYPE.LETTER && !isDigitalDelivery && (
                            <div data-di-mask className="receipt-order-details-card__credentials-text">
                                <Text>{TEXT.RECEIPT.CREDENTIALS}</Text>
                            </div>
                        )}
                    </Text>
                    {showTrackingInfo && <Text mt="300">{TEXT.RECEIPT.TRACKING_SMS}</Text>}
                </>
            )}
            {children}
        </Card.Content>
    </Card>
);

export default ReceiptOrderDetailsCard;
